// extCustomColumns.reducer.js
import constants from "../../commonUtils/constants";
import { sanitizeId } from "../../commonUtils/extraction.helper";
import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  filters: { keyword: "" },
  ExtCustomColumnsList: constants.extraction.listInitialState,
  tempSelections: {
    selected_columns: [],
    custom_columns: []
  },
  extCustomColumn: constants.extraction.initialState.extCustomColumn,
  openDrawer: false,
  errors: {},
  errorMessage: ""
};

const ExtCustomColumns = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
      
    case actionTypes.SET_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };
      
    case actionTypes.SET_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    
    case actionTypes.SET_OPEN_DRAWER:
      return {
        ...state,
        openDrawer: action.payload,
      };
    
    case actionTypes.SET_EXT_CUSTOM_COLUMN:
      return {
        ...state,
        extCustomColumn: action.payload,
      };
      
    case actionTypes.SET_TEMP_SELECTIONS:
      return {
        ...state,
        tempSelections: action.payload,
      };

    case actionTypes.GET_EXT_CUSTOM_COLUMNS_SUCCESS:
      return {
        ...state,
        loading: false,
        ExtCustomColumnsList: action.payload,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.GET_EXT_CUSTOM_COLUMNS_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to fetch data groups"
      };

    case actionTypes.GET_EXT_CUSTOM_COLUMN_SUCCESS:
    return {
        ...state,
        loading: false,
        extCustomColumn: sanitizeId(action.payload),
        errors: {},
        errorMessage: "",
    };
    
    case actionTypes.GET_EXT_CUSTOM_COLUMN_FAILURE:
      return {
        ...state,
        loading: false,
        openDrawer: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to fetch data groups"
      };
      
    case actionTypes.CREATE_EXT_CUSTOM_COLUMN_SUCCESS:
      return {
        ...state,
        loading: false,
        extCustomColumn: sanitizeId(action.payload),
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.CREATE_EXT_CUSTOM_COLUMN_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to create data group"
      };
      
    case actionTypes.UPDATE_EXT_CUSTOM_COLUMN_SUCCESS:
      const updatedCustomColumn = sanitizeId(action.payload);
      const updatedCustomColumnId = String(updatedCustomColumn.id || '');
      const currentListData = state.ExtCustomColumnsList?.data || [];
      const nextListData = currentListData.map((item) => {
        const itemId = String(item?._id || item?.id || '');
        if (itemId !== updatedCustomColumnId) return item;
        return {
          ...item,
          ...updatedCustomColumn,
          _id: item._id || updatedCustomColumn.id,
        };
      });

      return {
        ...state,
        loading: false,
        openDrawer: false,
        extCustomColumn: updatedCustomColumn,
        ExtCustomColumnsList: {
          ...state.ExtCustomColumnsList,
          data: nextListData,
        },
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.UPDATE_EXT_CUSTOM_COLUMN_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors || {},
        errorMessage: action.payload.message || "Failed to update data group"
      };
    
    case actionTypes.UPDATE_EXT_CUSTOM_COLUMNS_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.UPDATE_EXT_CUSTOM_COLUMNS_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to update order"
      };
    
    case actionTypes.DELETE_EXT_CUSTOM_COLUMN_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.DELETE_EXT_CUSTOM_COLUMN_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to delete data group"
      };
    case actionTypes.DETACH_EXT_CUSTOM_COLUMN_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.DETACH_EXT_CUSTOM_COLUMN_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to detach data group"
      };
      
    case actionTypes.RESET_CUSTOM_COLUMN_FORM:
      return {
        ...state,
        loading: false,
        extCustomColumn: constants.extraction.initialState.extCustomColumn,
        errors: {},
        errorMessage: "",
      };
      
    default:
      return state;
  }
};

export default ExtCustomColumns;